var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.codes.length > 1)?_c('v-btn-toggle',{staticClass:"currency-toggle",attrs:{"value":_vm.value,"mandatory":"","dense":"","color":"primary"},on:{"change":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.codes),function(code){return _c('v-btn',{key:code,attrs:{"small":"","value":code}},[_vm._v(_vm._s(code))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }